import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from '../../../linknet-common/globals/global.service';
import { CampaignService, WebshopService } from '../../../linknet-common/restful-services/restful.service';
import { CreditEnquiryComponent } from '../credit-enquiry/credit-enquiry.component';
import { CommonServicesService } from 'app/linknet-common/common-services/common-services.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'shop-app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  public logIndata: any;
  public subMenu: boolean = false;
  public showMenu: boolean = false;
  public getUserCurrentBudget: any;
  public userPaymentByInvoiceStatus: boolean = false;
  public isParentCustomer: boolean = false;
  public isVoucherKart: boolean = false;
  public isMobile: boolean;
  isSmartworks: boolean = false;
  isHrm: boolean = false;
  @ViewChild('creditInquiryModal') creditInquiryModal:CreditEnquiryComponent;
  isPenna:boolean = false;
  princepipes:boolean = false;
  @ViewChild("campaignModal") public campaignModal;
  public loaderShow: Boolean = false;
  public campaignList = [];
  public balancePoints: any = 0;
  public isParentWebshop: Boolean = true;
  public getShoppingCartIDList: any;
  public campaignName;
  public cartParams: any;
  voyagekart: boolean = false;
  constructor(public _httpWebshopService: WebshopService,public campaignService: CampaignService,private commonService: CommonServicesService,public router: Router,
    private toastr: ToastrService,private _http: WebshopService,
    public globalService: GlobalService) {
      if (/Android|webOS|iPhone|iPad|iPod|pocket|psp|kindle|avantgo|blazer|midori|Tablet|Palm|maemo|plucker|phone|BlackBerry|symbian|IEMobile|mobile|ZuneWP7|Windows Phone|Opera Mini/i.test(navigator.userAgent)) {
				this.isMobile = true;
			} else {
				this.isMobile = false;
			}
    this.logIndata = this.globalService.getLoggedInData();
    const webshopDetail = JSON.parse(sessionStorage.getItem('webshopDetail'));
      if(webshopDetail && webshopDetail.DomainName === "princepipes"){
        this.princepipes = true;
      }
      this.voyagekart = webshopDetail && webshopDetail.DomainName === "voyagekart";

      if(webshopDetail.ParentCustomerDomainName === webshopDetail.DomainName){
        this.isParentCustomer = true;
        if(webshopDetail.DomainName === "smartworks"){
          this.isSmartworks = true;
        }
        if(webshopDetail.DomainName === "247hrm"){
          this.isHrm = true;
        }
      }else{
        this.isParentCustomer = false;
        if(webshopDetail.DomainName === "voucherkart"){
          this.isVoucherKart = true;
        }else if(webshopDetail.DomainName === "sw"){
          this.isSmartworks = true;
        }
        else if(webshopDetail.DomainName === "247hrm"){
          this.isHrm = true;
        }
      }
      if(webshopDetail.DomainName === "pc"){
        this.isPenna = true;
      }
  }

  ngOnInit() {
    if (this.logIndata !== null) {
      this.userPaymentByInvoiceStatus = this.logIndata.PaymentByInvoice;
      if (this.userPaymentByInvoiceStatus) {
        this._httpWebshopService.getUserCurrentBudget().subscribe(
          (data: any[]) => {
            this.getUserCurrentBudget = data;
          });
      }
    }
    this.showMenu = true;
  }

  hideMenu() {
    this.showMenu = false;
    if(this.isMobile){
      var otherelement = document.querySelectorAll(".header-two .navbar-collapse.show")[0] as HTMLElement;
      if(otherelement){
        var closeelement = document.querySelectorAll(".header-two .navbar-toggler")[0] as HTMLElement;
        closeelement.click();
      }
      var element = document.querySelectorAll(".navbar-toggler")[0] as HTMLElement;
      if(element){
        element.click();
      }
    }
  }

  showMenus() {
    this.showMenu = true;
  }

  showMenuEvent(event){
    this.showMenu = event;
    this.hideMenu();
  }

  removeSessionItem() {
    sessionStorage.removeItem('pageIndex');
    sessionStorage.removeItem('pageSize');
  }
  changeCampaign(){
    if (this.princepipes || this.voyagekart) {
      this.campaignModal.show({
        backdrop: 'static',
				keyboard: false
      });
    };
    this.loaderShow = true;
    this.campaignService.getCampaignForUser().subscribe((data: any) => {
      if(data) {
        //sessionStorage.setItem('campaign', JSON.stringify(data))
        this.loaderShow = false;
        this.campaignList = data;
        if(this.isVoucherKart){
          this.campaignList = this.campaignList.filter((e:any)=>{return e.CampaignDesc === "voucherkart"});
          this.campaignService.setActiveCampaign(177);
          this.campaignSelect(this.campaignList[0]);
          this.balancePoints = this.campaignList[0].BalancePoints
          this.commonService.setPoints(this.campaignList[0].BalancePoints);
        }else{
          if(this.isSmartworks && !this.isParentWebshop){
            this.campaignService.setActiveCampaign(295);
            this.campaignSelect(this.campaignList[0]);
          }
         else{
            this.campaignList = this.campaignList.filter((e:any)=>{ return e.Aprovel === 'Aproved'});
          }
        }
      }
    },_error=>{
      this.loaderShow = false;
    });
  }

  campaignSelect(id) {
    let a = this.campaignList;
    sessionStorage.setItem('campaign', JSON.stringify(this.campaignList))
    if (!a || (a['CampaignId'] !== id['CampaignId'])) {
      sessionStorage.setItem('campaign', JSON.stringify(id));
      this.commonService.setPoints(id.BalancePoints);
      this.campaignService.setActiveCampaign(id);
    }
    this.campaignName = id['CampaignName'];
    this.campaignModal.hide();
    if(!this.isVoucherKart && !this.isSmartworks){
      this.deleteShoppingCart();
    }
    if(this.router.url  !== '/'){
      this.router.navigate(['/']);
    }
  }

  deleteShoppingCart() {
    const sessionShoppingCartData = JSON.parse(sessionStorage.getItem("shoppingCartDatas"));
    let a = JSON.parse(sessionStorage.getItem('campaign'));
    this.getShoppingCartIDList = [];
    if (sessionShoppingCartData && sessionShoppingCartData.length > 0) {
      let len3 = sessionShoppingCartData.length;
      for (let i = 0; i < len3; i++) {
        this.getShoppingCartIDList.push(sessionShoppingCartData[i].ShoppingCartItemID);
      }
    }
    if (this.getShoppingCartIDList.length > 0) {
      const userSettings = this.globalService.getUserSettings();
      const webShopSettings = this.globalService.webShopSettings();
      const loggedInData = this.globalService.getLoggedInData();
      
      if (loggedInData !== null) {
        this.cartParams = {
          UserID: loggedInData.UserID,
          CustomerID: webShopSettings.CustomerID,
          CurrencyID: userSettings.CurrencyID,
          DeleteShoppingCartItemIDs: this.getShoppingCartIDList,
        };
      } else {
        this.cartParams = {
          UserID: null,
          CustomerID: webShopSettings.CustomerID,
          CurrencyID: userSettings.CurrencyID,
          DeleteShoppingCartItemIDs: this.getShoppingCartIDList,
        };
      }
      try {
        this._http.deleteShoppingCartItem(this.cartParams).subscribe(
          (_data) => {
            this.campaignService.setCartStatus(true)
          },
          (error) => {
            this.toastr.error(error);
          }
        );
      } catch (error) {
        this.toastr.error(error);
      }
    }

  }
}
